import axios from 'axios';
import md5 from 'js-md5';
import { ElLoading, ElMessageBox  } from 'element-plus';

axios.defaults.timeout = 10000;
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = 'http://localhost:5000/app';
} else {
  axios.defaults.baseURL = 'https://gongcha-app-api.uz-apps.com/app';
}
axios.defaults.baseURL = 'https://gongcha-app-api.uz-apps.com/app';
// Suga testing
// 限制快速点击
var requesting = [];
var limitTime = 1000;
var requestingId = '';

let loadingInstance;

//http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');
    // const
    config.data = JSON.stringify(config.data);

    config.headers = {
      'Content-Type': 'application/json'
    };

    let nowTime = new Date().getTime();

    requestingId = md5.hex(JSON.stringify(config));

    // 限制快速点击
    requesting = requesting.filter(item => {
      return item.startTime + limitTime > nowTime;
    });
    let sessionUrl = requesting.filter(item => {
      return item.requestingId === requestingId;
    });
    if (sessionUrl.length > 0) {
      return config;
    }
    let item = {
      requestingId: requestingId,
      startTime: nowTime
    };
    requesting.push(item);

    // if(token){
    //   config.params = {'token':token}
    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    let result = response.data;
    if (
      result &&
      result.code &&
      result.msg &&
      result.code != 200 &&
      (result.msg.includes('timed out') || result.msg.includes('openId') || result.msg.includes('memberId'))  
    ) {
      showWarnMsg(
        '現在、データの取得に失敗しました。数分後に再試行してください。'
      );
    }
    return response;
  },
  error => {
    // Check API: /check-slot
    const requestUrl = error.config?.url || '';
    const isCheckSlotAPI = requestUrl.endsWith('/check-slot') || requestUrl.includes('/check-slot');
    if (isCheckSlotAPI && error.message.includes('Network Error')) {
      return Promise.reject(error);
    }

    // 判断请求异常信息中是否含有超时timeout字符串
    if (error.message.includes('timeout')) {
      showWarnMsg(
        '現在、データの取得に失敗しました。数分後に再試行してください。'
      );
    } else if (error.message.includes('Network Error')) {
      showWarnMsg(
        'サーバーが大変混み合っています。 <br/> 申し訳ございませんが、しばらくたってからやり直してください'
      );
    } else if (error.message.includes('openId') || error.message.includes('memberId')) {
      showWarnMsg(
        'サーバーが大変混み合っています。 <br/> 申し訳ございませんが、しばらくたってからやり直してください'
      );
    }
    return Promise.reject(error);
  }
);

function showWarnMsg(warnMsg) {
  ElMessageBox .alert(warnMsg, '', {
    dangerouslyUseHTMLString: true,
    confirmButtonText: '閉じる',
    type: 'warning',
    showClose: false,
    center: true,
    iconClass: 'el-message-box-title-icon',
    confirmButtonClass: 'el-message-box-confirm-btn'
  })
    .then(() => {
      closePage();
    })
    .catch(() => {});
}

// 兼容所有浏览器关闭页面方法
function closePage() {
  if (liff) {
    liff.closeWindow();
  } else {
    if (navigator.userAgent.indexOf('MSIE') > 0) {
      if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
        window.opener = null;
        window.close();
      } else {
        window.open('', '_top').close();
      }
    } else if (navigator.userAgent.indexOf('Firefox') > 0) {
      //火狐默认状态非window.open的页面window.close是无效的
      window.location.href = 'about:blank ';
    } else {
      window.opener = null;
      window.open('about:blank', '_top').close();
    }
  }
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, disibleLoading) {
  if (!disibleLoading) {
    loadingInstance = ElLoading.service({
      fullscreen: true,
      text: 'Now Loading...'
    });
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    ).finally(() => {
      if (!disibleLoading) {
        loadingInstance.close();
      }
    });
  });
}
